import type { SportSliderDict } from '@draftkings/sportsbook-labels';

export const dict: SportSliderDict = {
    arrowLeft: 'Arrow pointing left icon',
    arrowRight: 'Arrow pointing right icon',
    refresh: 'Refresh',
    logo: 'logo',
    live: 'Icon indicating a live or in-progress event',
    sgpLinkTitle: 'Open game in SGP mode'
};
